export default "/images/918beb499d9898a5acd348a340999748.avif";